export default {

    layout: {
        errorWindowVisible: false,
    },

    info : {
        ajaxErrorInfo : '尚未发生任何错误' ,
    }

}